import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=170451a3&"
import script from "./Book.vue?vue&type=script&lang=js&"
export * from "./Book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170451a3')) {
      api.createRecord('170451a3', component.options)
    } else {
      api.reload('170451a3', component.options)
    }
    module.hot.accept("./Book.vue?vue&type=template&id=170451a3&", function () {
      api.rerender('170451a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Book.vue"
export default component.exports